/**
 * Static catalog descriptors for the EVAR workflow.
 *
 * This list is always loaded (no lazy loading) and used to populate
 * the catalog picker dropdown. It contains no item data.
 */

import type { ICatalogDescriptor } from '@/workflows/vascular/common/catalog';

export const EVAR_CATALOG_DESCRIPTORS: ICatalogDescriptor[] = [
    // ── AUI (Uni-Iliac) ──
    //{ id: 'artivion-etegra-aui', manufacturer: 'Artivion', model: 'E-tegra AUI', category: 'aui' },
    //{ id: 'cook-flex-aui', manufacturer: 'Cook', model: 'Flex AUI', category: 'aui' },
    //{ id: 'cook-renu-ce', manufacturer: 'Cook', model: 'Renu (CE)', category: 'aui' },
    //{ id: 'cook-renu-fda', manufacturer: 'Cook', model: 'Renu (FDA)', category: 'aui' },
    //{ id: 'lifetech-ankura-aui', manufacturer: 'LifeTech', model: 'Ankura AUI', category: 'aui' },
    //{
    //    id: 'medtronic-endurant-aui',
    //    manufacturer: 'Medtronic',
    //    model: 'Endurant AUI',
    //    category: 'aui',
    //},
    //{
    //    id: 'medtronic-endurant-ii-aui',
    //    manufacturer: 'Medtronic',
    //    model: 'Endurant II AUI',
    //    category: 'aui',
    //},
    //{ id: 'terumo-treo-aui', manufacturer: 'Terumo Aortic', model: 'Treo AUI', category: 'aui' },

    // ── Bifurcated ──
    {
        id: 'artivion-etegra',
        manufacturer: 'Artivion',
        model: 'E-tegra',
        category: 'bifurcated',
        logo: '/report/logos/artivion.png',
    },
    //{
    //    id: 'artivion-eventus-bx',
    //    manufacturer: 'Artivion',
    //    model: 'E-ventus BX',
    //    category: 'bifurcated',
    //},
    //{
    //    id: 'artivion-eliac-isolated',
    //    manufacturer: 'Artivion',
    //    model: 'E-liac Isolated',
    //    category: 'bifurcated',
    //},
    {
        id: 'cook-zenith-alpha',
        manufacturer: 'Cook',
        model: 'Zenith Alpha Abdominal',
        category: 'bifurcated',
        logo: '/report/logos/cook.png',
    },
    //{
    //    id: 'cook-zenith-flex',
    //    manufacturer: 'Cook',
    //    model: 'Zenith Flex',
    //    category: 'bifurcated',
    //},
    //{ id: 'cook-zenith-zbis', manufacturer: 'Cook', model: 'Zenith ZBIS', category: 'bifurcated' },
    //{ id: 'cordis-incraft', manufacturer: 'Cordis', model: 'Incraft', category: 'bifurcated' },
    //{
    //    id: 'endologix-ovation-alto',
    //    manufacturer: 'Endologix',
    //    model: 'Ovation Alto',
    //    category: 'bifurcated',
    //},
    //{
    //    id: 'endologix-afx2-ce',
    //    manufacturer: 'Endologix',
    //    model: 'AFX2 (CE)',
    //    category: 'bifurcated',
    //},
    //{
    //    id: 'endologix-afx2-fda',
    //    manufacturer: 'Endologix',
    //    model: 'AFX2 (FDA)',
    //    category: 'bifurcated',
    //},
    {
        id: 'gore-excluder-ous',
        manufacturer: 'Gore',
        model: 'Excluder (OUS)',
        category: 'bifurcated',
        logo: '/report/logos/gore.png',
    },
    //{
    //    id: 'gore-excluder-us',
    //    manufacturer: 'Gore',
    //    model: 'Excluder (US)',
    //    category: 'bifurcated',
    //},
    //{
    //    id: 'gore-excluder-conformable-ous',
    //    manufacturer: 'Gore',
    //    model: 'Excluder Conformable (OUS)',
    //    category: 'bifurcated',
    //},
    //{
    //    id: 'gore-excluder-conformable-us',
    //    manufacturer: 'Gore',
    //    model: 'Excluder Conformable (US)',
    //    category: 'bifurcated',
    //},
    //{
    //    id: 'lifetech-ankura-aaa',
    //    manufacturer: 'LifeTech',
    //    model: 'Ankura AAA',
    //    category: 'bifurcated',
    //},
    //{ id: 'lombard-altura', manufacturer: 'Lombard', model: 'Altura', category: 'bifurcated' },
    //{ id: 'lombard-aorfix', manufacturer: 'Lombard', model: 'Aorfix', category: 'bifurcated' },
    //{
    //    id: 'medtronic-endurant-ii-ous',
    //    manufacturer: 'Medtronic',
    //    model: 'Endurant II (OUS)',
    //    category: 'bifurcated',
    //},
    //{
    //    id: 'medtronic-endurant-ii-us',
    //    manufacturer: 'Medtronic',
    //    model: 'Endurant II (US)',
    //    category: 'bifurcated',
    //},
    {
        id: 'medtronic-endurant-iis-ous',
        manufacturer: 'Medtronic',
        model: 'Endurant IIs (OUS)',
        category: 'bifurcated',
        logo: '/report/logos/medtronic.png',
    },
    //{
    //    id: 'medtronic-endurant-iis-us',
    //    manufacturer: 'Medtronic',
    //    model: 'Endurant IIs (US)',
    //    category: 'bifurcated',
    //},
    //{
    //    id: 'microport-hercules-b',
    //    manufacturer: 'Microport',
    //    model: 'Hercules B',
    //    category: 'bifurcated',
    //},
    //{
    //    id: 'terumo-anaconda',
    //    manufacturer: 'Terumo Aortic',
    //    model: 'Anaconda',
    //    category: 'bifurcated',
    //},
    {
        id: 'terumo-treo-ous',
        manufacturer: 'Terumo Aortic',
        model: 'Treo (OUS)',
        category: 'bifurcated',
        logo: '/report/logos/terumo-aortic.png',
    },
    //{
    //    id: 'terumo-treo-us',
    //    manufacturer: 'Terumo Aortic',
    //    model: 'Treo (US)',
    //    category: 'bifurcated',
    //},
    //{
    //    id: 'terumo-treovance',
    //    manufacturer: 'Terumo Aortic',
    //    model: 'Treovance',
    //    category: 'bifurcated',
    //},
    //{
    //    id: 'microport-minos-eu',
    //    manufacturer: 'Microport',
    //    model: 'Minos EU',
    //    category: 'bifurcated',
    //},
    //{
    //    id: 'microport-minos-row',
    //    manufacturer: 'Microport',
    //    model: 'Minos ROW',
    //    category: 'bifurcated',
    //},
];
